import { createFileRoute } from '@tanstack/react-router';

import { EmbedsSetupPage } from './-components/EmbedsSetupPage';

export const Route = createFileRoute('/_authenticated/externalContent/embeds/new')({
    component: EmbedsSetupPage,
});
